import type {
  GlucoseSpecialValue,
  GlucoseEvent as GlucoseUserEvent,
} from "@tandemdiabetes/sugarmate-api-react-client"
import type { DeepReadonlyObject } from "rxdb"

export const defaultTitle = "Sugarmate"

export function setTitle(title: string) {
  document.title = title
}

export function getTitle(
  displayTime: (time: string) => string,
  displayGlucoseString: (reading: number, specialValue: GlucoseSpecialValue) => string,
  glucoseUserEvent?: DeepReadonlyObject<GlucoseUserEvent> | null,
) {
  if (glucoseUserEvent) {
    const formattedGlucoseString = displayGlucoseString(
      glucoseUserEvent.glucose.mg_dl,
      glucoseUserEvent.glucose.special_value,
    )
    const time = displayTime(glucoseUserEvent.started_at)

    return `${formattedGlucoseString} ${time}`
  }

  return defaultTitle
}
